<template>
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-accent">
          <h4 class="mb-0 text-white fs-1vw">دورنما و مسیر ارتقا شغلی</h4>
        </div>
        <div class="card-body">
          <div>
            <label class="form-label fw-bold">دورنما و مسیر ارتقا شغلی</label>
            <textarea
                class="form-control"
                rows="3"
                placeholder="دورنما و مسیر ارتقا شغلی را وارد کنید"
                v-model="jobQualification.career_path"
            ></textarea>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    },
  }
}
</script>
